// Query keys centralizadas y jerárquicas del dominio preinvoice.
export const preInvoiceKeys = {
  all: ["preinvoice"],
  list: () => [...preInvoiceKeys.all, "list"],
  userProfile: () => [...preInvoiceKeys.all, "user-profile"],
};
